<div class="page-assets-component mat-typography" fxLayout="column" fxLayoutGap="0px">

  <div id="searchSection" fxLayout="column">
    <mat-form-field>
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="e.g. Headphones">
    </mat-form-field>
  </div>

  <mat-divider></mat-divider>
    
  <div id="tableSection">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows matSort class="mat-elevation-z8 data-table">

        <ng-container matColumnDef="_id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>id</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element._id}}</mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef mat-sort-header>title</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.title}}</mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>description</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="hint">
          <mat-header-cell *matHeaderCellDef mat-sort-header>hint</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.hint}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-stroked-button color="primary" class="hide" (click)="newAssetFromTemplate(element)">New from this</button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="state">
          <mat-header-cell *matHeaderCellDef mat-sort-header id="stateColumnHeader">state</mat-header-cell>
          <mat-cell *matCellDef="let asset">
            <span id="stateColumn">{{asset.getState().name}}</span>
            <mat-icon matSuffix [ngStyle]="{'color': asset.getState().color}">{{asset.getState().icon}}</mat-icon>
          </mat-cell>
        </ng-container>
    
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;" (press)="openAsset(element)" class="actionButton"></mat-row>
    </mat-table>
  </div>
    
</div>
